import apiService from './index';

const ME_ENDPOINT = 'user/me';
const COMPANY_ENDPOINT = 'ocr/company/';


export default {
  update(user) {
    return apiService.patch(ME_ENDPOINT, user);
  },
  get() {
    return apiService.get(ME_ENDPOINT);
  },
  setDefaultCompany(company_id) {
    return apiService.patch(ME_ENDPOINT, {'default_ocr_company':company_id});
  },
  getCompany() {
    return apiService.get(`${COMPANY_ENDPOINT}ordered/`);
  },
  createCompany(company) {
    return apiService.post(COMPANY_ENDPOINT, company, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  updateCompany(companyId, formData) {
    return apiService.patch(`${COMPANY_ENDPOINT}${companyId}/`, formData);
  },
  deleteCompany(company) {
    return apiService.delete(`${COMPANY_ENDPOINT}${company.id}/`);
  },
  changePassword(currentPassword, newPassword) {
    return apiService.put('/user/change-password', {
      old_password: currentPassword,
      new_password: newPassword,
    });
  },
  checkPassword(password) {
    return apiService.post('/user/check-password', {
      current_password: password
    });
  },
  updateWebhookUrl(url) {
    return apiService.post('/user/create-webhook-url', url);
  },
  reset(email) {
    return apiService.post('/auth/password-reset/', {email});
  },
  validatePasswordToken(token) {
    return apiService.post('/auth/password-reset/validate_token/', { token });
  },
  confirmResetPassword(token, password) {
    return apiService.post('/auth/password-reset/confirm/', { token, password });
  },
  toggleAvailability() {
    return apiService.post('/user/availability/toggle/');
  },
  getAvailabilityStatus() {
    return apiService.get('/user/availability/status/');
  },
};